var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fix-width"},[_c('div',{staticClass:"bb"},[_c('navbar'),_c('sidebar'),_c('router-view'),_c('footbar')],1),(_vm.isLoading)?_c('loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }